import { ChartPieIcon } from './ChartPieIcon';

/**
 * author: Google
 * id 9C6B53C5-698B-4428-9738-A6700BF8698C
 * name chart-pie
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-pie.svg
 * tags
 * - Math 
 */
export const ReportPieIcon = ChartPieIcon;
export default ReportPieIcon